import React, { useRef } from "react";
import Card from "../Card/Card";
import { useNavigate } from "react-router-dom";
import "./Secoes.css";

function SecaoAutomatica({ titulo, tag, projetos, id, handleCardClick }) {
  const navigate = useNavigate();
  const onCardClick = handleCardClick || ((id) => navigate(`/projeto/${id}`));

  const projetosFiltrados = projetos.filter((p) => p.tags.includes(tag));
  const scrollRef = useRef(null); // 🔹 referência do container

  if (projetosFiltrados.length === 0) return null;

  // 🔹 Funções para mover o carrossel
  const scrollLeft = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  // 🔹 Função para abrir a página da categoria
  const irParaCategoria = () => {
    const rota = tag
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // remove acentos
      .toLowerCase()
      .replace(/\s+/g, ""); // remove espaços

    navigate(`/${rota}`);
  };



  return (
    <section className="secao-automatica" id={id}>
      <div className="secao-cabecalho">
        <h2>{titulo}</h2>
        <button className="btn-ver-todos" onClick={irParaCategoria}>
          Ver todos →
        </button>
      </div>

      <div className="carousel-wrapper">
        <button className="carousel-btn left" onClick={scrollLeft}>❮</button>

        <div className="cards-container" ref={scrollRef}>
          {projetosFiltrados.map((projeto) => (
            <Card key={projeto.id} projeto={projeto} onClick={onCardClick} />
          ))}
        </div>

        <button className="carousel-btn right" onClick={scrollRight}>❯</button>
      </div>
    </section>
  );
}

export default SecaoAutomatica;
